import Markdown from 'react-markdown';
import type { Components } from 'react-markdown';
import { normalizeMaestroMarkdown } from './maestroMarkdown';
import { parseMaestroResult } from './maestroResultModel';
import './MaestroReply.less';

const markdownComponents: Components = {
  h1: ({ children }) => <h3>{children}</h3>,
  h2: ({ children }) => <h3>{children}</h3>,
  h3: ({ children }) => <h3>{children}</h3>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  ),
};

export default function MaestroReply({
  content,
  className = '',
}: {
  content: string;
  className?: string;
}) {
  const model = parseMaestroResult(content);
  const remainder = normalizeMaestroMarkdown(model.remainder);
  const hasStructure = model.metrics.length + model.groups.length + model.findings.length + model.steps.length > 0;

  if (!hasStructure && !model.lead && !remainder) {
    return <div className={`maestro-result ${className}`.trim()}>No response available</div>;
  }

  return (
    <div className={`maestro-result ${className}`.trim()} data-kind={model.kind}>
      <div className="maestro-result__top">
        <span className="maestro-result__kicker">{model.kicker}</span>
        <span className="maestro-result__live" aria-hidden="true" />
      </div>
      {model.title ? <div className="maestro-result__title">{model.title}</div> : null}
      {model.lead ? <p className="maestro-result__lead">{model.lead}</p> : null}

      {model.metrics.length > 0 && (
        <div
          className="maestro-result__metrics"
          style={{ gridTemplateColumns: `repeat(${Math.min(model.metrics.length, 3)}, minmax(0, 1fr))` }}
        >
          {model.metrics.map((metric) => (
            <div key={metric.key} className="maestro-result__metric">
              <div className="maestro-result__metric-n">{metric.count}</div>
              <div className="maestro-result__metric-l">{metric.label}</div>
            </div>
          ))}
        </div>
      )}

      {model.groups.map((group) => (
        <div key={group.key} className="maestro-result__group">
          <div className="maestro-result__group-l">{group.label}</div>
          <div className="maestro-result__chips">
            {group.items.map((item) => (
              <span key={item} className="maestro-result__chip" title={item}>
                {item}
              </span>
            ))}
            {group.more > 0 ? <span className="maestro-result__more">+{group.more}</span> : null}
          </div>
        </div>
      ))}

      {model.findings.map((finding) => (
        <div key={finding.title} className="maestro-result__finding">
          {finding.title ? <div className="maestro-result__group-l">{finding.title}</div> : null}
          {finding.body ? <p className="maestro-result__lead">{finding.body}</p> : null}
        </div>
      ))}

      {model.steps.length > 0 && (
        <ol className="maestro-result__steps">
          {model.steps.map((step) => (
            <li key={step.n + step.text}>
              <span className="maestro-result__n">{step.n}</span>
              <span>{step.text}</span>
            </li>
          ))}
        </ol>
      )}

      {remainder ? (
        <div className="maestro-result__prose">
          <Markdown components={markdownComponents}>{remainder}</Markdown>
        </div>
      ) : null}
    </div>
  );
}
